<template>
  <div class="app-content-wrapper">
    <div class="top-wrapper">
      <!-- <p class="risk-name">{{ libInfo.libAlias }}</p> -->
      <!-- <div class="risk-info">
        <div class="risk-info-item">
          <p class="risk-info-item-desc">{{ $t('message.risk.listType') }}</p>
          <p class="risk-info-item-value">{{ libInfo.typeText }}</p>
        </div>
        <div class="risk-info-item">
          <p class="risk-info-item-desc">{{ $t('message.risk.listAttribute') }}</p>
          <p class="risk-info-item-value">{{ libInfo.riskDecisionText }}</p>
        </div>
        <div class="risk-info-item">
          <p class="risk-info-item-desc">{{ $t('message.risk.creator') }}</p>
          <p class="risk-info-item-value">{{ libInfo.createOpr }}</p>
        </div>
        <div class="risk-info-item">
          <p class="risk-info-item-desc">{{ $t('message.risk.lastModifiedDate') }}</p>
          <p class="risk-info-item-value">{{ libInfo.updateTime }}</p>
        </div>
      </div> -->
      <details-top-info :lib-info="libInfo" />
    </div>
    <div class="table-top-box">
      <div class="table-top-box-left">
        <el-button icon="el-icon-plus" size="small" @click="handleAdd">
          {{ $t('message.risk.addBlackListItem.addItems') }}
        </el-button>
      </div>
      <div class="table-top-box-right">
        <!-- <div class="search-input-wrapper">
          <el-input class="search-input" size="small" v-model="searchValue"
            :placeholder="$t('message.risk.searchItems')" suffix-icon="el-icon-search" @blur="handleSearch">
          </el-input>
        </div> -->
        <!-- <div class="search-select-wrapper">
          <el-select class="search-select" size="small" v-model="searchStatus"
            :placeholder="$t('message.risk.status.allStatus')" @change="handleSearch">
            <el-option :label="$t('message.risk.status.allStatus')" value="" />
            <el-option :label="$t('message.risk.status.active')" value="active" />
            <el-option :label="$t('message.risk.status.inactive')" value="inactive" />
            <el-option :label="$t('message.risk.status.expiringSoon')" value="expiringSoon" />
          </el-select>
        </div> -->
        <oner-button borderColor="#00B42A" textColor="#00B42A" hoverColor="rgb(0, 180, 42,0.05)"
          style="margin-right: 16px;" :icon="require('@/assets/image/icon-selected.png')"
          @click="handleBatchEdit('0', 'status')" v-if="selectedRows.length > 0">
          {{ $t('message.risk.activateSelected') }}
        </oner-button>
        <oner-button borderColor="#F53F3F" textColor="#F53F3F" hoverColor="rgb(245, 63, 63,0.05)"
          style="margin-right: 16px;" :icon="require('@/assets/image/icon-unselected.png')"
          @click="handleBatchEdit('1', 'status')" v-if="selectedRows.length > 0">
          {{ $t('message.risk.deactivateSelected') }}
        </oner-button>
        <oner-button borderColor="#3F69F5" textColor="#3F69F5" hoverColor="rgb(63, 105, 245,0.05)"
          style="margin-right: 16px;" :icon="require('@/assets/image/icon-updateData.png')"
          @click="handleBatchEdit('', 'handleExpirationTime')" v-if="selectedRows.length > 0">
          {{ $t('message.risk.updateExpireDate') }}
        </oner-button>
        <oner-button borderColor="#D0D5DD" textColor="#1A202C" hoverColor="rgb(26, 32, 44,0.05)"
          :icon="require('@/assets/image/icon-export.png')" @click="handleExport">
          {{ $t('message.risk.export') }}
        </oner-button>
      </div>
    </div>
    <div class="table-wrapper">
      <custom-table ref="table" :table-set="tableCondition" :service-function="fetchRiskDetailList"
        :showDirectOperationBtn="true" router-name="/risk/detail" @selection-change="handleSelectionChange"
        :showSelection="true" :showRowSelection="true">
        <template v-slot:buttons="{ row }">
          <el-switch v-model="row.status" @change="handleSwitchItem(row)"></el-switch>
        </template>
      </custom-table>

    </div>
    <validate-drawer ref="validationDrawer" :withHeader="false"
      :titleText="$t('message.risk.addBlackListItem.addItemsToBlacklist')"
      :submitButtonText="$t('message.risk.addBlackListItem.addItems')" :showCancelButton="true"
      :default-function="addInfo" @refresh="onRefresh">
      <template #prefix>
        <oner-tab :tabs="TAB_LIST" v-model="curTabKey" />
        <add-black-list-item-single ref="addBlackListItemSingle" v-if="curTabKey === 'MANUAL_INPUT'"
          v-model="addBlackListItemSingleParams" @refresh="onRefresh" :libInfo="libInfo" />
        <add-black-list-item-batch ref="addBlackListItemBatch" v-if="curTabKey === 'UPLOAD_CSV'" :libInfo="libInfo" />
      </template>
    </validate-drawer>
    <custom-message ref="customMessage"></custom-message>
    <validate-model ref="validateModel" :titleText="$t('message.risk.setExpireDate')"
      :validation-condition="validateModelCondition" :default-function="handleBatchEditHttp"
      @refresh="onRefresh"></validate-model>
  </div>
</template>
<script>

import ValidateDrawer from '@/components/modal/base-modal/validate-drawer.vue';
import ValidateModel from '@/components/modal/base-modal/validation-modal.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import OnerButton from '@/componentsV2/base-cmps/button/index.vue';
import OnerTab from '@/componentsV2/base-cmps/tab/index.vue';
import { getEnantiomericValue } from '@/utils/tools/constant';
import { formatDateDisplay } from '@/utils/tools/time';
import { RISK_DECISION, RISK_FACTOR, TAB_LIST } from '@/views/risk/api/options';
import {
  queryRiskDetailList, updateLibDetailStatus,
  batchAddRiskLibDetail, addRiskLibDetailById, getLibSummary,
  batchEdit, exportRiskLibDetail,
  manualBatchAddByServiceIds, manualBatchAddByValues,
} from '@/views/risk/api/risk';
import AddBlackListItemBatch from '@/views/risk/components/add-blackList-item/batch.vue';
import DetailsTopInfo from '@/views/risk/components/add-blackList-item/details-topinfo.vue';
import AddBlackListItemSingle from '@/views/risk/components/add-blackList-item/single.vue';

export default {
  components: {
    CustomTable,
    CustomMessage,
    ValidateDrawer,
    ValidateModel,
    OnerTab,
    AddBlackListItemSingle,
    AddBlackListItemBatch,
    DetailsTopInfo,
    OnerButton,
  },
  data() {
    return {
      curTabKey: '',
      TAB_LIST,
      addBlackListItemSingleParams: {},
      riskLibraryId: '',
      libInfo: {},
      addBlackListItemParams: {},
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.risk.value' },
          key: 'value',
          type: 'text',
          textFunc: (row) => {
            return row.type === 'CARD_NUMBER_HASH' ? row.remarks : row.value;
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'status',
          type: 'status',
          textFunc: data => +data.status === 1 ? 'message.common.enable' : 'message.common.disable',
          isInternationalization: true,
        },
        {
          titleBar: { type: 'text', title: 'message.risk.effectiveDate' },
          key: 'expirationTime',
          type: 'text',
          textFunc: (row) => {
            if (!row.expirationTime) {
              return this.$t('message.user.longEffective');
            }
            return formatDateDisplay(row.expirationTime, 'yyyy-MM-dd');
          },
          itemStyle: (row) => {
            if (row.expirationTime && new Date(row.expirationTime) < new Date()) {
              return { color: '#FF7D00' };
            }
            return {};
          },
        },
        // hit count
        {
          titleBar: { type: 'text', title: 'message.risk.hitCount30Day' },
          key: 'hitCount',
          type: 'text',
          align: 'right',
        },
        // last hit time
        {
          titleBar: { type: 'text', title: 'message.risk.lastHitTime' },
          key: 'lastHit',
          type: 'text',
          textFunc: (row) => {
            return row.lastHit ? formatDateDisplay(row.lastHit, 'yyyy-MM-dd HH:mm:ss') : '-';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.risk.addBy' },
          key: 'updateOpr',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.risk.createDate' },
          key: 'updateTime',
          type: 'text',
        },

        // {
        //   key: 'buttons',
        //   titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
        //   type: 'slot',
        //   itemMinWidth: 80,
        // },
        {
          key: 'operations',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          itemMinWidth: 70,
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: (data) => {
                return data.status ? 'message.common.disableOperationText' : 'message.common.enableOperationText';
              },
              isInternationalization: true,
              func: (row) => {
                this.handleBatchEdit(row.status ? '0' : '1', 'status', [row]);
              },
              isDisplayFunc: () => true,
            },
            {
              type: 'text_button',
              textFunc: () => 'message.risk.setExpireDate',
              isInternationalization: true,
              func: (row) => {
                this.handleBatchEdit('', 'handleExpirationTime', [row]);
              },
              isDisplayFunc: () => true,
            },
          ],
        },
      ],
      submitErrorMessage: '',
      failFileUrl: '',
      item1Placeholder: '',
      searchValue: '',
      searchStatus: '',
      selectedRows: [],
      validateModelCondition: [
        {
          key: 'expirationTime',
          name: 'message.risk.expireDate',
          type: 'date_time',
          defValue: new Date().toISOString().split('T')[0],
          isShowStar: true,
          dateType: 'date',
          dateFormat: 'yyyy-MM-dd HH:mm:ss',
          dateValueFormat: 'yyyy-MM-dd HH:mm:ss',
          pickerOptions: {
            disabledDate(time) {
              // return time.getTime() < Date.now() - 8.64e7;
              return time.getTime() < Date.now();
            },
          },
        },
      ],
      batchEditParams: {},
    };
  },
  created() {
    const {
      riskLibraryId, riskListName, type, createOpr,
      updateTime, riskDecision, riskLibraryName, _status,
      productType,
    } = this.$route.query;
    this.riskLibraryId = riskLibraryId;
    this.libInfo = {
      libAlias: riskListName,
      type,
      typeText: this.$t(getEnantiomericValue(RISK_FACTOR, type)),
      riskDecisionText: this.$t(getEnantiomericValue(RISK_DECISION, riskDecision)),
      createOpr,
      updateTime,
      riskLibraryName,
      id: riskLibraryId,
      status: _status,
      productType,
    };
    this.getLibSummary();
  },

  methods: {
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async fetchRiskDetailList(params = {}) {
      return queryRiskDetailList({ riskLibraryId: this.riskLibraryId, ...params });
    },
    onRefresh() {
      this.$refs.table.refreshTable();
      this.getLibSummary();
    },
    handleAdd() {
      this.submitErrorMessage = '';
      this.failFileUrl = '';
      this.$refs.validationDrawer.openDrawerAndCallBack();
    },
    handleSwitchItem(item) {
      const status = item.status;
      this.$refs.customMessage.openHttpModal({
        contentHtml: this.$t('message.risk.confirmTip', { operate: status ? this.$t('message.common.enable').toLowerCase() : this.$t('message.common.disable').toLowerCase() }),
        titleHtml: this.$t('message.common.prompt'),
        httpFunction: updateLibDetailStatus,
        params: {
          id: item.id,
          status: status ? 0 : 1,
        },
        successFunction: this.onRefresh,
        cancelFunction: () => {
          // 取消后复原
          item.status = !status;
        },
      }, '');
    },
    async addInfo() {
      let data;
      let errMsg;
      if (this.curTabKey === 'MANUAL_INPUT') {
        try {
          const validateResult = await this.$refs.addBlackListItemSingle.toFormValid();
          console.log(validateResult, 'validateResult');

          if (!validateResult.valid) {
            return Promise.reject(this.$t('message.common.formDataError'));
          }

          const formData = validateResult.formData;
          if (!formData) {
            return Promise.reject(new Error(this.$t('message.common.formDataError')));
          }
          console.log(formData, 'formData');

          // 判断values 是否存在\n,存在则切割
          const values = formData?.values.split('\n')?.map(item => item.trim()).filter(item => item !== '');
          this.addBlackListItemParams = {
            values,
            riskLibraryId: this.riskLibraryId,
            serviceIds: values,
            type: this.libInfo.type,
            riskLibraryName: this.libInfo.riskLibraryName,
            expirationTime: formData.expirationTime,
            status: formData.status,
            addOneType: formData.addOneType ? 'byServiceId' : 'byCardNumber',
          };
          if (formData.addOneType) {
            await manualBatchAddByServiceIds(this.addBlackListItemParams);
          } else {
            await manualBatchAddByValues(this.addBlackListItemParams);
          }
        } catch (error) {
          // 如果error.message 包含 “已存在” 则提示 “message.risk.addBlackListItem.exist”
        }
      } else {
        if (this.failFileUrl) { // 若失败文件存在则下载
          window.location.href = this.failFileUrl;
        }
        const item2File = this.$refs.addBlackListItemBatch?.getFormJson()?.item2File;
        if (!item2File) {
          errMsg = this.$t('message.common.uploadFile');
          ShowErrorMessage(errMsg);
          return Promise.reject(new Error(errMsg));
        }
        data = new FormData();
        data.append('file', item2File);
        data.append('riskLibraryId', this.riskLibraryId);
        data.append('type', this.libInfo.type);
        data.append('riskLibraryName', this.libInfo.riskLibraryName);
        const res = await batchAddRiskLibDetail(data);
        if (res) {
          this.failFileUrl = res;
          this.submitErrorMessage = this.$t('message.risk.batchFileError');
        }
      }
    },
    handleSearch() {
      this.$refs.table.refreshTable();
    },
    async getLibSummary() {
      const res = await getLibSummary({ riskLibraryId: this.riskLibraryId });
      if (res) {
        this.libInfo = { ...this.libInfo, ...res };
      }
    },
    async handleExport() {
      const { riskLibraryId } = this.$route.query;
      const res = riskLibraryId && await exportRiskLibDetail({ riskLibraryId });
      if (res) {
        const a = document.createElement('a');
        a.href = res;
        a.download = res;
        a.click();
        // 使用完成移除
        document.body.removeChild(a);
      }
    },
    async handleBatchEdit(status, type, rows = null) {
      const selectedRows = rows || this.selectedRows;
      const _status = rows ? status === '0' ? '1' : '0' : status;
      if (selectedRows.length === 0) {
        ShowErrorMessage(this.$t('message.risk.pleaseSelectItems'));
        return;
      }
      const params = {
        ids: rows ? rows.map(item => item.id) : selectedRows.map(item => item.value.itemData.id),
        expirationTime: '',
        status: _status,
        handleType: type === 'status' ? 'handleStatus' : 'handleExpirationTime',
      };
      this.batchEditParams = params;
      switch (type) {
        case 'status':
          this.$refs.customMessage.openHttpModal({
            contentHtml: this.$t('message.risk.confirmTips', { operate: _status === '0' ? this.$t('message.common.enableOperation') : this.$t('message.common.disableOperation') }),
            titleHtml: this.$t('message.common.prompt'),
            httpFunction: batchEdit,
            params,
            successFunction: this.onRefresh,
          }, '');
          break;
        case 'handleExpirationTime':
          this.$refs.validateModel.openModalAndCallBack(async (form) => {
            form.assignmentFormValue({ ...params, expirationTime: form.expirationTime });
          });
      }
    },
    async handleBatchEditHttp(params) {
      try {
        await batchEdit({ ...this.batchEditParams, ...params });
      } catch (error) {
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

::v-deep {
  .custom_item1 {
    .el-form-item__content {
      margin-top: 60px;
    }
  }

  .addOneType {
    position: absolute;
    top: 120px;

    .el-form-item__label {
      display: none;
    }
  }
}

.top-wrapper {
  margin-bottom: 30px;

  .risk-name {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: $color-text-primary;
    line-height: 32px;
    margin-bottom: 20px;
  }

  .risk-info {
    min-height: 85px;
    background: $color-default;
    display: flex;
    align-items: center;
    padding: 0 20px;

    .risk-info-item {
      flex: 1;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 32px;

      .risk-info-item-desc {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }

      .risk-info-item-value {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }
  }
}

.table-top-box {
  width: 100%;
  display: flex;
  // flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 40px;
  margin-bottom: 16px;

  .table-top-box-left {
    width: 110px;
  }

  .table-top-box-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: calc(100% - 110px);
    // margin-top: 40px;
    // margin-bottom: 16px;

  }

}
</style>
